module.exports = __webpack_public_path__ + "static/media/bottoms2.d865073d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bottoms2.png
// module id = 1734
// module chunks = 0 1